import(/* webpackMode: "eager", webpackExports: ["Glass"] */ "/vercel/path0/app/_components/marketing/glass.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/_lib/assets/images/bg-lined.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(routes)/(header-and-footer)/send-review/components/review-form.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
